var map = {
	"./nav-list.de-CH.json": 1100,
	"./nav-list.de-DE.json": 1101,
	"./nav-list.en-CA.json": 1102,
	"./nav-list.en-GB.json": 1103,
	"./nav-list.en-IN.json": 1104,
	"./nav-list.en-ME.json": 1105,
	"./nav-list.en-US.json": 1106,
	"./nav-list.es-EM.json": 1107,
	"./nav-list.es-ES.json": 1108,
	"./nav-list.fr-BE.json": 1109,
	"./nav-list.fr-CA.json": 1110,
	"./nav-list.fr-CH.json": 1111,
	"./nav-list.nl-BE.json": 1112,
	"./nav-list.nl-NL.json": 1113,
	"./nav-list.pl-PL.json": 1114,
	"./nav-list.pt-BR.json": 1115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1099;